var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fixed-header',{attrs:{"threshold":_vm.threshold},on:{"change":_vm.updateFixedStatus}},[_c('div',[_c('div',{staticClass:"header"},[_c('main-container',[_c('header-logo',{attrs:{"small":_vm.sticky}}),_c('header-user',{attrs:{"initialName":_vm.user.fullName,"permission":_vm.user.permission}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }